// FeaturesSection.jsx
// FIX: Replaced requestAnimationFrame + scrollTop with pure CSS @keyframes.
// scrollTop writes force the browser to do layout recalculations every frame,
// fighting the scroll compositor. CSS animations run on the GPU compositor thread
// and never block scrolling.
import React from 'react';

const FeaturesSection = () => {
  const features = {
    left: [
      {
        id: 1,
        icon: '📊',
        title: 'Results-Driven Approach',
        description: 'We focus on strategies that don\'t just look good'
      },
      {
        id: 2,
        icon: '⚙️',
        title: 'Customized Solutions',
        description: 'Every brand is built different. We tailor every campaign.'
      },
      {
        id: 3,
        icon: '👥',
        title: 'Full-Services Team',
        description: 'From content creation to paid ads and SEO'
      }
    ],
    right: [
      {
        id: 4,
        icon: '💬',
        title: 'Transparent Communication',
        description: 'You are always in the loop with all the regular updates.'
      },
      {
        id: 5,
        icon: '💰',
        title: 'Affordable & Scalable',
        description: 'Whether you are a startup or a large scaling enterprise'
      },
      {
        id: 6,
        icon: '🎯',
        title: 'Client-Centric Mindset',
        description: 'Your success is our mission. We treat your brand like it\'s our own.'
      }
    ]
  };

  const images = [
    '/images/feature1.jpg',
    '/images/feature2.jpg',
    '/images/feature3.jpg',
    '/images/feature4.jpg',
    '/images/feature5.jpg',
    '/images/feature6.jpg',
    '/images/feature7.jpg',
    '/images/feature8.jpg',
  ];

  // Duplicate images for seamless CSS loop (same pattern as BannerSection)
  const doubled = [...images, ...images];

  return (
    <>
      <style>{`
        @keyframes fs-scroll-down {
          0%   { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
        @keyframes fs-scroll-up {
          0%   { transform: translateY(-50%); }
          100% { transform: translateY(0); }
        }

        .fs-sliding-wrapper {
          display: flex;
          gap: 12px;
          height: 520px;
          overflow: hidden;
        }

        /* Pause on hover — applied to the wrapper so both columns pause together */
        .fs-sliding-wrapper:hover .fs-track-down,
        .fs-sliding-wrapper:hover .fs-track-up {
          animation-play-state: paused;
        }

        .fs-col {
          flex: 1;
          overflow: hidden;
        }

        .fs-track-down {
          display: flex;
          flex-direction: column;
          gap: 12px;
          animation: fs-scroll-down 22s linear infinite;
          will-change: transform;
        }

        .fs-track-up {
          display: flex;
          flex-direction: column;
          gap: 12px;
          animation: fs-scroll-up 22s linear infinite;
          will-change: transform;
        }

        .fs-img-card {
          width: 100%;
          aspect-ratio: 4 / 3;
          border-radius: 12px;
          overflow: hidden;
          flex-shrink: 0;
        }

        .fs-img-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          pointer-events: none;
        }
      `}</style>

      <section className="features-showcase-section">
        <div className="container">
          <div className="row align-items-center g-4">
            {/* Left Features Column */}
            <div className="col-lg-3 col-md-6">
              <div className="features-column">
                {features.left.map((feature, index) => (
                  <div key={feature.id} className="feature-card-showcase">
                    <div className="feature-number">0{index + 1}</div>
                    <div className="feature-icon-wrapper">
                      <div className="feature-icon-box">
                        <span className="feature-emoji">{feature.icon}</span>
                      </div>
                      <h3 className="feature-title-showcase">{feature.title}</h3>
                    </div>
                    <p className="feature-description-showcase">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Middle Sliding Images — pure CSS now */}
            <div className="col-lg-6 col-md-12">
              <div className="fs-sliding-wrapper">
                {/* Column 1 — scroll down */}
                <div className="fs-col">
                  <div className="fs-track-down">
                    {doubled.map((img, idx) => (
                      <div key={`col1-${idx}`} className="fs-img-card">
                        <img src={img} alt="" loading="lazy" />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Column 2 — scroll up */}
                <div className="fs-col">
                  <div className="fs-track-up">
                    {doubled.map((img, idx) => (
                      <div key={`col2-${idx}`} className="fs-img-card">
                        <img src={img} alt="" loading="lazy" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Features Column */}
            <div className="col-lg-3 col-md-6">
              <div className="features-column">
                {features.right.map((feature, index) => (
                  <div key={feature.id} className="feature-card-showcase">
                    <div className="feature-number">0{index + 4}</div>
                    <div className="feature-icon-wrapper">
                      <div className="feature-icon-box">
                        <span className="feature-emoji">{feature.icon}</span>
                      </div>
                      <h3 className="feature-title-showcase">{feature.title}</h3>
                    </div>
                    <p className="feature-description-showcase">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeaturesSection;